export default __webpack_public_path__ + "img/Positive.d1318efc.png";